/*!
 * EGT — /ig  (the link in EGT's Instagram bio).
 *
 * Founder direction 2026-10-28 ("Concept C · Now / Next postcards", picked from three
 * mockups saved in temp/ig-concepts-2026-10-28/): more on one phone screen, smaller
 * frosted tiles that are still easy to tap, and the journal up top.
 *
 *   - A full-height frosted RAIL on the left replaces the top nav: the coin, icon-only
 *     links (The Making, podcasts, contact), "EGT · THE UNIVERSE" set vertically, and
 *     log in at the bottom.
 *   - NOW / NEXT: the newest entry of The Making beside a countdown to the next one.
 *     The page is pre-built, so /src/egt.ig.js fills both from /api/content/latest
 *     (the same feed as the homepage); until then the Now card links to /journal and
 *     the Next card offers the email list.
 *   - A row of quick-link chips, then a postcard mosaic in four sizes (1×1, 2×1, 1×2,
 *     2×2): the free opening of Exploit, the film, the studio, the albums, the
 *     platform, Intrepid, the founder and the Forge.
 *   - The background is one of the platform's 18 photos (the journal's set), picked
 *     once per visit before first paint. No scrim: contrast comes from the frosted
 *     glass (agents.md §4).
 */

var _ = require("../../uam/module.js")(module.exports, {
  namespace: "egt.ig",
  title: "EGT — start here",
  description: "The EGT gateway for new arrivals: the newest letter from The Making, the free opening of the novel Exploit, the film, the AI film studio, the platform and the music.",
  supportServer: true
});
var S = require("../helpers/egt.sections.js");
var J = require("../helpers/egt.journal.views.js");

function icon(paths) {
  return { n: "svg", c: "egt-ig__i", viewBox: "0 0 24 24", "aria-hidden": "true",
    i: paths.map(function (d) { return { n: "path", d: d }; }) };
}
var ICONS = {
  pen: [ "M12 20h9", "M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" ],
  mic: [ "M12 2a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z", "M5 10a7 7 0 0 0 14 0", "M12 17v5" ],
  mail: [ "M5 5h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z", "m3 7 9 6 9-6" ],
  user: [ "M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z", "M4 21a8 8 0 0 1 16 0" ],
  book: [ "M4 19.5V5a2 2 0 0 1 2-2h14v16H6.5a2.5 2.5 0 0 0 0 5H20" ]
};

function railLink(href, label, ic, on) {
  return { n: "a", c: "egt-ig__rl" + (on ? " is-on" : ""), href: href, "aria-label": label, title: label, i: icon(ICONS[ic]) };
}

function rail() {
  return { n: "nav", c: "egt-ig__rail", "aria-label": "EGT", i: [
    { n: "a", c: "egt-ig__coin", href: "/", "aria-label": "EGT home", i: { n: "img", src: "/logo.svg", alt: "", width: "34", height: "34" } },
    railLink("/journal", "The Making, the founder's journal", "pen", true),
    railLink("/podcasts", "Podcasts", "mic"),
    railLink("/contact-us", "Contact us", "mail"),
    { n: "span", c: "egt-ig__vt", "aria-hidden": "true", i: "EGT · THE UNIVERSE" },
    railLink("https://dashboard.egt.studio", "Log in", "user")
  ] };
}

/* NOW (newest entry) and NEXT (countdown). Filled by /src/egt.ig.js. */
function nowNext() {
  return { n: "div", c: "egt-ig__nn", i: [
    { n: "a", c: "egt-ig__now egt-ig__paper", href: "/journal", "data-ig": "now", i: [
      { n: "span", c: "egt-ig__k", "data-f": "kicker", i: "Now · The Making" },
      { n: "span", c: "egt-ig__now-img", i: { n: "img", "data-f": "img", src: "/imgs/journal/piotr-chrobot-6oUsyeYXgTg.jpg", alt: "", decoding: "async" } },
      { n: "span", c: "egt-ig__now-t", "data-f": "title", i: "The founder's journal" },
      { n: "span", c: "egt-ig__now-go", "data-f": "meta", i: "Read the letters →" }
    ] },
    { n: "div", c: "egt-ig__next egt-ig__dark", "data-ig": "next", i: [
      { n: "span", c: "egt-ig__k egt-ig__k--gold", i: "Next" },
      { n: "div", c: "egt-ig__cd", "data-ig": "cd", hidden: "hidden", i: [
        { n: "span", c: "egt-ig__n", i: [ { n: "b", "data-u": "d", i: "0" }, { n: "span", c: "egt-ig__k", i: "days" } ] },
        { n: "span", c: "egt-ig__n", i: [ { n: "b", "data-u": "h", i: "00" }, { n: "span", c: "egt-ig__k", i: "hrs" } ] },
        { n: "span", c: "egt-ig__n", i: [ { n: "b", "data-u": "m", i: "00" }, { n: "span", c: "egt-ig__k", i: "min" } ] }
      ] },
      { n: "span", c: "egt-ig__next-msg", "data-f": "nextday", i: "A new letter, straight to your inbox." },
      { n: "a", c: "egt-ig__em", href: "/journal#subscribe", i: "Email me" }
    ] }
  ] };
}

function chip(href, img, label) {
  return { n: "a", c: "egt-ig__chip egt-ig__paper", href: href, i: [
    { n: "img", src: img, alt: "", loading: "lazy", decoding: "async" }, { n: "span", i: label } ] };
}

function chips() {
  return { n: "div", c: "egt-ig__chips", "data-scroll-hint": "", i: [
    chip("/entertainment/the-journey-of-the-coin", "/imgs/coin/j06.jpg", "Film"),
    chip("/studio", "/imgs/egt-studio-hero.jpg", "Studio"),
    chip("/intrepid", "/imgs/egt-intrepid-canvas.jpg", "Intrepid"),
    chip("/podcasts", "/imgs/podcasts/create-cover.jpg", "Podcasts"),
    chip("/entertainment", "/imgs/albums/solarys.jpg", "Music")
  ] };
}

/* A postcard: the photo fills it; a frosted caption sits on it. size: "", "wide", "tall", "big". */
function card(o) {
  var kids = [];
  if (o.img) { kids.push({ n: "img", c: "egt-ig__cv", src: o.img, alt: "", loading: o.eager ? undefined : "lazy", decoding: "async",
    fetchpriority: o.eager ? "high" : undefined }); }
  if (o.art) { kids.push({ n: "img", c: "egt-ig__art", src: o.art, alt: "", decoding: "async" }); }
  if (o.stamp) { kids.push({ n: "span", c: "egt-ig__stamp", "aria-hidden": "true", i: icon(ICONS.book) }); }
  if (o.covers) {
    kids.push({ n: "span", c: "egt-ig__k", i: o.kicker });
    kids.push({ n: "span", c: "egt-ig__stack", "aria-hidden": "true", i: o.covers.map(function (s) {
      return { n: "img", src: s, alt: "", loading: "lazy", decoding: "async" }; }) });
    kids.push({ n: "b", c: "egt-ig__ct", i: o.title });
  } else {
    var cap = [];
    if (o.kicker) { cap.push({ n: "span", c: "egt-ig__k", i: o.kicker }); }
    cap.push({ n: "b", c: "egt-ig__ct", i: o.title });
    if (o.go) { cap.push({ n: "span", c: "egt-ig__go", i: o.go }); }
    kids.push({ n: "span", c: "egt-ig__cap " + (o.dark ? "egt-ig__dark" : "egt-ig__paper") + (o.side ? " egt-ig__cap--side" : ""), i: cap });
  }
  return { n: "a", c: "egt-ig__pc" + (o.size ? " egt-ig__pc--" + o.size : "") + (o.cls ? " " + o.cls : ""),
    href: o.href, "aria-label": o.aria || undefined, i: kids };
}

function mosaic() {
  return { n: "div", c: "egt-ig__grid", i: [
    card({ size: "big", href: "/exploit/free", img: "/imgs/exploit/exploit-hero-bg.jpg", art: "/imgs/exploit/exploit-title-card.png", stamp: true, eager: true,
      kicker: "The novel · free opening", title: "Read the first seven chapters", aria: "Read the free opening of the novel Exploit" }),
    card({ size: "tall", href: "/entertainment/the-journey-of-the-coin", img: "/imgs/coin/j06.jpg",
      kicker: "Our first film", title: "The Journey of the Coin" }),
    card({ href: "/studio", img: "/imgs/egt-studio-hero.jpg", dark: true, title: [ S.egtMark(), " Studio" ], aria: "EGT Studio, the AI film studio" }),
    card({ href: "/entertainment", covers: [ "/imgs/albums/exploit-act-1.jpg", "/imgs/albums/solarys.jpg", "/imgs/albums/anchored.jpg" ],
      kicker: "Streaming now", title: "The albums", cls: "egt-ig__paper egt-ig__pc--covers" }),
    card({ size: "wide", href: "/platform", img: "/imgs/egt-platform-canvas.jpg", side: true,
      kicker: "The Universe Platform", title: "Your whole business, one place", go: "Reserve a spot →" }),
    card({ href: "/intrepid", img: "/imgs/egt-intrepid-canvas.jpg", dark: true, title: "Intrepid", aria: "Intrepid, your AI partner" }),
    card({ href: "/founder", img: "/imgs/founder/justin.jpg", title: "The founder" }),
    { n: "a", c: "egt-ig__forge egt-ig__dark", href: "/forge", i: [
      { n: "span", i: "The Forge · sites, apps, campaigns" }, { n: "span", c: "egt-ig__go", i: "Work with us →" } ] }
  ] };
}

/* The background: one of the platform's photos, picked once per visit before first paint. */
var BG_DEFAULT = "piotr-chrobot-6oUsyeYXgTg";
function background() {
  var list = JSON.stringify(J.BACKGROUNDS || [ BG_DEFAULT ]);
  return [
    { n: "div", c: "egt-ig__bg", "aria-hidden": "true", i:
      { n: "img", id: "egt-ig-bg", src: "/imgs/journal/" + BG_DEFAULT + ".jpg", alt: "", fetchpriority: "high", decoding: "async" } },
    { n: "script", i: "(function(){try{var l=" + list + ",i=document.getElementById('egt-ig-bg');if(i&&l.length){i.src='/imgs/journal/'+l[Math.floor(Math.random()*l.length)]+'.jpg'}}catch(e){}})();" }
  ];
}

function igSchema() {
  var O = S.siteOrigin();
  return S.jsonLd([
    { "@type": "WebPage", "@id": O + "/ig#webpage", url: O + "/ig",
      name: "EGT — start here",
      description: "The EGT gateway for new arrivals: the newest letter from The Making, the free opening of the novel Exploit, the film, the AI film studio, the platform and the music.",
      isPartOf: { "@id": O + "/#website" },
      about: { "@id": O + "/#organization" },
      breadcrumb: { "@id": O + "/ig#breadcrumb" } },
    { "@type": "BreadcrumbList", "@id": O + "/ig#breadcrumb",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: O + "/" },
        { "@type": "ListItem", position: 2, name: "Start here" }
      ] }
  ]);
}

exports.render = async function render() {
  var content = { n: "div", c: "egt-ig", i: [ igSchema() ].concat(background()).concat([
    rail(),
    { n: "div", c: "egt-ig__wrap", i: [ { n: "h1", c: "egt-ig__h", i: "EGT — start here" }, nowNext(), chips(), mosaic() ] },
    { n: "script", src: "/src/egt.ig.js", defer: "defer" }
  ]) };
  return S.page("/exploit", [ content ], { noNav: true, hideNavCta: true });
};
